import { TextField, TextFieldProps } from "@mui/material";
import { FieldPath, FieldValues, useController } from "react-hook-form";
import { ChangeEvent } from "react";
import { isElementInArray } from "../Utils/arrays";
import { MdmFormProps } from "./MdmFormProps";
import { texFieldDefaultColumnProps, textFieldDefaultProps } from "./TextFieldDefaultProps";
import { RhfInputProps } from "./RhfInputProps";

type Props = {
  direction?: "row" | "column";
  onChange?: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  ignoreFormDisabledState?: boolean;
};

export const TextFieldInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name,
  label,
  required,
  disabledFields,
  disabled,
  direction = "row",
  onChange,
  ignoreFormDisabledState = false,
  ...otherProps
}: RhfInputProps<TFieldValues, TName> & MdmFormProps & TextFieldProps & Props) => {
  const {
    field,
    fieldState: { error },
    formState: { disabled: isFormDisabled },
  } = useController({
    control,
    name,
  });

  return (
    <TextField
      {...field}
      {...(direction === "row" ? textFieldDefaultProps : texFieldDefaultColumnProps)}
      {...otherProps}
      label={label || name}
      inputRef={field.ref}
      required={required}
      onChange={(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        field.onChange(event);
        onChange?.(event);
      }}
      error={!!error}
      helperText={error?.message}
      disabled={
        (!ignoreFormDisabledState && isFormDisabled) ||
        disabled ||
        isElementInArray(disabledFields, name)
      }
    />
  );
};
